<!-- Changes needed for UK -->
<div class="container">
	<b
		>{{ "uk_finprom_global_warning_text" | translate }}
		<a [href]="getUrl()" target="_blank">{{ "uk_finprom_global_warning_link" | translate }}</a>
	</b>
</div>